<template>
  <div id="why">
      <h3>Why Choose Us?</h3>
      <span>The smoothest way to order your favourite foods. &#128526;</span>
      <div class="d-flex why">
          <div class="first">
              <Icons name="connect" />
              <h4>Customers-Restaurants Connection</h4>
              <p>
                  We stand as a bridge and a connector between our users and their favourite restaurants, Our users don't need to change restaurant as we work hard to bring their favourite restaurant on-board.
              </p>
          </div>
          <div class="second">
              <Icons name="utensil" />
              <h4>Best Rated Meals and Restaurants</h4>
              <p>
                  We provide top-rated meals from various top-rated restaurants to you and we let our users rate the meals and restaurants to help other users make the right choice.
              </p>
          </div>
          <div class="first">
              <Icons name="truck" />
              <h4>Fast and Reliable Delivery System</h4>
              <p>
                  We make sure to use a trusted, fast and reliable delivery system to have your meal(s) delivered to you at the fastest way possible and also in one piece.
              </p>
          </div>
      </div>
      <a href="https://play.google.com/store/apps/details?id=com.ccr.mealtrips" target="_blank"><button class="get">Get the App</button></a>
  </div>
</template>

<script>
import Icons from './Icons.vue'

export default {
    name: 'Why',
    components: {
        Icons
    }
}
</script>

<style lang="scss" scoped>
#why{
    background: url('../assets/svg/Union.svg');
    background-size: cover;
    background-position: center;
    z-index: 1;
    position: relative;
    height: 160vh;
    padding: 116px 8%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -10%;
    font-family: 'Raleway', sans-serif;
    a:hover{
        text-decoration: none;
    }
    h3{
        font-size: 36px;
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
    }
    span{
        font-size: 24px;
        width: 442px;
        text-align: center;
        margin-bottom: 80px;
    }
    .why{
        width: 100%;
        height: 100%;
        margin-bottom: 48px;
        h4{
            font-size: 24px;
            margin-top: 28px;
            margin-bottom: 24px;
            font-weight: 700;
        }
        .first{
            padding: 20px 30px;
            text-align: center;
            align-self: flex-start;
        }
        .second{
            padding: 20px 30px;
            text-align: center;
            align-self: flex-end;
        }
        p{
            text-align: left;
            font-size: 18px;
        }
    }
    .get{
      background: #E56E10;
      padding: 16px 32px;
      border-radius: 24px;
      color: #fefefe;
      border: none;
      margin: auto;
    }
}

@media (max-width: 480px) {
    #why{
    background: url('../assets/svg/Union.svg');
    background-size: cover;
    background-position: center;
    z-index: 1;
    position: relative;
    height: auto;
    padding: 100px 8%;
    padding-bottom: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -40%;
    font-family: 'Raleway', sans-serif;
    h3{
        font-size: 22px;
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
    }
    span{
        font-size: 18px;
        width: 80%;
        text-align: center;
        margin-bottom: 80px;
    }
    .why{
        width: 100%;
        height: 100%;
        margin-bottom: 48px;
        flex-direction: column;
        h4{
            font-size: 18px;
            margin-top: 28px;
            margin-bottom: 24px;
            font-weight: 700;
        }
        .first{
            padding: 20px 30px;
            text-align: center;
            align-self: flex-start;
            width: 100%;
        }
        .second{
            padding: 20px 30px;
            text-align: center;
            align-self: flex-end;
            width: 100%;
        }
        p{
            text-align: left;
            font-size: 16px;
        }
    }
    .get{
      background: #E56E10;
      padding: 16px 32px;
      border-radius: 24px;
      color: #fefefe;
      border: none;
      margin: auto;
    }
}
}

@media (min-width: 481px) and (max-width: 768px) {
    #why{
    background: url('../assets/svg/Union.svg');
    background-size: cover;
    background-position: center;
    z-index: 1;
    position: relative;
    height: auto;
    padding: 100px 8%;
    padding-bottom: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -26%;
    font-family: 'Raleway', sans-serif;
    h3{
        font-size: 22px;
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
    }
    span{
        font-size: 18px;
        width: 80%;
        text-align: center;
        margin-bottom: 80px;
    }
    .why{
        width: 100%;
        height: 100%;
        margin-bottom: 48px;
        flex-direction: column;
        h4{
            font-size: 18px;
            margin-top: 28px;
            margin-bottom: 24px;
            font-weight: 700;
        }
        .first{
            padding: 20px 30px;
            text-align: center;
            align-self: flex-start;
            width: 100%;
        }
        .second{
            padding: 20px 30px;
            text-align: center;
            align-self: flex-end;
            width: 100%;
        }
        p{
            text-align: left;
            font-size: 16px;
        }
    }
    .get{
      background: #E56E10;
      padding: 16px 32px;
      border-radius: 24px;
      color: #fefefe;
      border: none;
      margin: auto;
    }
}
}

@media (min-width: 769px) and (max-width: 1024px) {
    #why{
    background: url('../assets/svg/Union.svg');
    background-size: cover;
    background-position: center;
    z-index: 1;
    position: relative;
    height: auto;
    padding: 100px 8%;
    padding-bottom: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -15%;
    font-family: 'Raleway', sans-serif;
    h3{
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
    }
    span{
        width: 80%;
        text-align: center;
        margin-bottom: 80px;
    }
    .why{
        width: 100%;
        height: 100%;
        margin-bottom: 48px;
        flex-direction: column;
        h4{
            margin-top: 28px;
            margin-bottom: 24px;
            font-weight: 700;
        }
        .first{
            padding: 20px 30px;
            text-align: center;
            align-self: flex-start;
            width: 60%;
        }
        .second{
            padding: 20px 30px;
            text-align: center;
            align-self: flex-end;
            width: 60%;
        }
        p{
            text-align: left;
        }
    }
    .get{
      background: #E56E10;
      padding: 16px 32px;
      border-radius: 24px;
      color: #fefefe;
      border: none;
      margin: auto;
    }
}
}
</style>